// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAlertsModal_container__o8oog","content":"JobAlertsModal_content__79ml_"};